import React, { useCallback, useState } from 'react';
import Illustrator from '../Illustrator';

const IllustratorContainer = () => {
  return <Illustrator />;
};

export default IllustratorContainer;
